<template>
<v-container>
  <v-dialog v-model="Showdialog" scrollable persistent>
    <v-card>
      <v-toolbar color='primary' dark>
        <v-card-title dark> <v-icon color='white'>mdi-database-export</v-icon>&nbsp;Uploader</v-card-title>
      </v-toolbar>
      <v-card-text style="max-height: 500px;">
          <v-simple-table>
            <thead>
              <tr>
                <th class="text-left">Nombre</th>
                <th class="text-left">Status</th>
                <th class="text-left">Upload</th>
                <th class="text-left">Remove</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in files2" :key="item.file.name">
                <td>{{ item.file.name }}</td>
                <td>
                  <div>
                    <v-progress-circular
                      color = 'primary'
                      :indeterminate = item.rotate>
                      <v-icon color='primary' v-if="item.check">mdi-check-bold</v-icon>
                      <v-icon color='red' v-if="item.noCheck">mdi-close</v-icon>
                    </v-progress-circular>
                  </div>
                </td>
                <td >
                  <v-btn @click="uploadOne(item)" text :disabled="item.rotate" v-if="!item.check">
                    <v-icon color='blue'>mdi-cloud-upload</v-icon>
                  </v-btn> 
                </td>
                <td>
                  <v-btn @click="deleteItem(item)" text :disabled="item.rotate" v-if="!item.check">
                      <v-btn text :disabled="item.rotate"><v-icon color='red'>mdi-delete-sweep</v-icon></v-btn>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </v-simple-table> 
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>  
        <v-btn
          class='button'
          color="primary"
          @click="imitir(); deleteList(); validate();" 
          :disabled="loading">
            Close
        </v-btn>
        <v-btn
          class='button'
          color="primary"
          v-if="files2.length > 1"
          @click.prevent ="uploadAll()" 
          :loading="loading">
          Upload all
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <Alert :show="alert"/>  
</v-container>
</template>

<script lang="ts">
  import Vue from 'vue'
  import Alert from '../utilitys/Alert.vue'
  import { api1 } from '../../globals/axios';

  export default Vue.extend({
    name: 'Loaderform',
    components:{
      Alert
    },
    data: () => ({
      loading: false,

      alert:{
        icon: null,
        show: false,
        text: null,
        color: null,
        time: 2000
      },
    }),
    props:['Showdialog','files','files2'],

    methods:{
      imitir: function(){
        this.$emit('Showdialog',false)
      },
      uploadOne: function(item){
        item.noCheck = false;
        item.check = false;

        this.loading= true;
        item.rotate = true;

        let fd = new FormData;
        fd.append('file',item.file);
        fd.set('data', JSON.stringify(item));

        api1({
            method: 'POST',
            'url': `/upload`,
            data: fd
        }).then(res=>{

          this.alert.show=true;
          this.alert.icon='mdi-check-circle'
          this.alert.text= res.data ? res.data.message : res;
          this.alert.color='success';

          this.loading=false;
          item.rotate=false;
          item.check=true;
        })
        .catch(error=>{

          this.loading=false;
          item.rotate=false;

          item.noCheck=true;
          this.alert.show=true;
          this.alert.icon='mdi-alert'
          this.alert.text=error.response ? error.response.data : error;
          this.alert.color='error';
        })
      },
      uploadAll: function(){
        for (let item of this.files2){
          item.rotate = true;
        }

        let fd = new FormData;
        for ( let file of this.files2){
          fd.set("data", JSON.stringify(file));
          fd.append('files',file.file);
        }
        api1({
            method: 'POST',
            'url': `/upload/all`,
            headers: { 'Content-Type' : 'multipart/form-data',  'Accept' : '*/*' },
            data:  fd 
        }).then(res=>{
          this.alert.show=true;
          this.alert.icon='mdi-check-circle'
          this.alert.text= res.data ? res.data.message : res;
          this.alert.color='success';
          this.loading=false;
          for(let a of res.data.files){
            const found = this.files2.find(x => x.file.name === a)
            if (found) {
              found.check = true;
              found.rotate = false;
            }
          }
        })
        .catch(error=>{ 
          this.loading=false
          for (let item of this.files2){
            item.rotate = false;
          }
          this.type='error';
          this.show=true;
          this.mensaje=error;
        })
      },

      deleteItem: function(item){
        let it = this.files2.indexOf(item.name);
        let it2 = this.files.indexOf(item.name);
        this.files2.splice(it,1);
        this.files.splice(it2,1);
        if(this.files2.length == 0){
          this.imitir();
        }
      },
      deleteList: function(){
        const filesCheck = this.files2.filter( item => !!item.check)
        for(let item of filesCheck){
          const idx = this.files2.indexOf(item);
          const idx1 = this.files.indexOf(item.file);
          this.files2.splice(idx,1)
          this.files.splice(idx1,1)
        }
      },
      validate: function(){
        this.$emit('validate');
      }
    }
  })
</script>
<style lang="scss" scoped>
  .button{
    width: 20% !important;
  }
</style>